import * as Request from 'request-promise'
import { CrudService  } from '../crud'

export class BillService extends CrudService {
    constructor(){
        super("bill")
    }

}


// WEBPACK FOOTER //
// ./src/services/crud/bill.js